import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`
    fragment GraveDigger on Funeral {
        GraveDigger {
            ${BookingsFragmentInclude}
        }
    }
`;
